import React, { useEffect, useState } from 'react';
import { Modal, Button, Header, Table, Icon, Message } from 'react-frontier';
import { PromoterContact } from '../SiteClasses';
import API from '../API';
import { Link } from 'react-router-dom';

interface PromoterContactModalProps{
	open: boolean;
	onClose: () => void;
	contact_id: number;
}

var PromoterContactModal = (props: PromoterContactModalProps)=>{
	var [contact, setContact] = useState<PromoterContact>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);

	useEffect(()=>{
		if(props.open && props.contact_id){
			getContact();
		}
	}, [props.open, props.contact_id]);

	var getContact = async()=>{
		setLoading(true);
		setModalPrompts([]);
		API.getPromoterContact(props.contact_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setContact(res.data);
		}).catch(err=>{
			setModalPrompts(['Hubo un error al cargar el contacto (LPC-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	return <Modal open={props.open} onClose={props.onClose} size="tiny">
		<Modal.Header>Información del Contacto</Modal.Header>
		{loading ? <Header loading text={'Cargando datos...'}/> : <Modal.Content>
			<Table fitted striped details data={[
				['ID', contact?.contact_id],
				['Nombre', contact?.contact_name],
				['Departamento', contact?.department || <Icon name='minus'/>],
				['Email', contact?.email || <Icon name='minus'/>],
				['Teléfono', contact?.phone || <Icon name='minus'/>],
			]} />
			<div style={{ textAlign: 'center', marginTop: 15 }}>
				<Button iconName='eye' color='black' text="Ver promotor" as={Link} to={`/promoters/${contact?.promoter_id}`}  target='_blank'/>
			</div>
			<Message style={{ marginTop: 15 }} type='error' list={modalPrompts} />
		</Modal.Content>}
		<Modal.Actions>
			<Button basic text="Cerrar" onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default PromoterContactModal;
